// @flow

import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';

import {
    CONTROL_SHARING_TOGGLE,
    ALLOWED_USER_ID,
    SET_CONTROLLER_ID,
    SET_STATUS_CONTROL,
    SET_SELF_CONTROL,
    ADD_WAITING_QUEUE,
    REMOVE_WAITING_QUEUE,
    EVENT_DATA_SERVICE,
    SET_ADMIN_STATE_CONTROL,
    SET_VIRTUAL_SCREEN_ID,
    SET_AUTOSTART_SHARING
} from './actionTypes';

/**
 * The default state.
 */
const DEFAULT_STATE = {
    active: null,
    isAutoStart: false,
    serviceResponse: {},
    controlledUserId: null,
    launchedControlID: null,
    virtualScreenID: null,
    statusControl: null,
    arrayQueue: new Map()
};

ReducerRegistry.register('wildix/features/control-sharing', (state = DEFAULT_STATE, action) => {

    switch (action.type) {

    case CONTROL_SHARING_TOGGLE:
        return updateControlState(state, action.controlState);

    case ALLOWED_USER_ID:
        return {
            ...state,
            controlledUserId: action.participantID
        };
    case EVENT_DATA_SERVICE:
        return {
            ...state,
            serviceResponse: action.serviceResponse
        };
    case SET_AUTOSTART_SHARING:
        return {
            ...state,
            isAutoStart: action.isAutoStart
        };
    case ADD_WAITING_QUEUE:
        return {
            ...state,
            arrayQueue: state.arrayQueue.set(action.userID, action.objectQueue)
        };
    case REMOVE_WAITING_QUEUE:
        action.deleteID ? state.arrayQueue.delete(action.deleteID) : state.arrayQueue.clear();

        return {
            ...state,
            arrayQueue: state.arrayQueue
        };
    case SET_CONTROLLER_ID:
        return {
            ...state,
            launchedControlID: action.participantID
        };
    case SET_VIRTUAL_SCREEN_ID:
        return {
            ...state,
            virtualScreenID: action.virtualScreenID
        };
    case SET_STATUS_CONTROL:
        return {
            ...state,
            statusControl: action.statusControl
        };
    case SET_SELF_CONTROL:
        return {
            ...state,
            isUserGivesSelfControl: action.isUserGivesSelfControl
        };
    case SET_ADMIN_STATE_CONTROL:
        return {
            ...state,
            isUserAdmin: action.isUserAdmin
        };
    }

    return state;
});


/**
 * Updates the chat status on opening the chat view.
 *
 * @param {Object} state - The Redux state of the feature.
 * @returns {Object}
 */
function updateControlState(state, controlState) {
    return {
        ...state,
        active: typeof controlState === 'boolean' ? controlState : !state.active
    };
}
